export const useSxStyles = () => {
  return {
    tooltipContainer: {
      display: 'inline-flex',
      overflow: 'hidden',
      '& a': {
        fontSize: 'inherit',
        marginBottom: '5px',
        paddingBottom: 0,
      },
    },
  };
};
